import { Component, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'qe-duo-check-icon',
	templateUrl: './two-tone-check.component.html',
})
export class TwoToneCheckIconComponent {
	@Input() public readonly color1?: string = 'var(--brandPrimary)';
	@Input() public readonly color2?: string = 'var(--white)';

	constructor() {}
}
